import ArchkNotificationDelete from 'archk-notification-delete';
import { architeckCall } from 'database';
import keys from 'keys';
import moment from 'moment';
import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { CSVExport, Search } from "react-bootstrap-table2-toolkit";
import { connect } from 'react-redux';
import { Card, CardBody, CardHeader, Col, FormGroup, Input, Modal, Row } from "reactstrap";
import { toggleAlert } from 'store/functions/system';


const { ExportCSVButton } = CSVExport;
const { SearchBar } = Search;

const pagination = paginationFactory({
    sizePerPage: 10,
    page: 1,
    alwaysShowAllBtns: true,
    showTotal: true,
    withFirstAndLast: false,
    sizePerPageRenderer: ({ options, currSizePerPage, onSizePerPageChange }) => (
        <div className="dataTables_length" id="datatable-basic_length">
            <label>
                Show{" "}
                {<select
                    name="datatable-basic_length"
                    aria-controls="datatable-basic"
                    className="form-control form-control-sm"
                    onChange={e => onSizePerPageChange(e.target.value)}
                >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                </select>}{" "}
                entries.
            </label>
        </div>
    )
});

const required_form_fields = [
    'minutes',
    'problems',
    'description',
]  

class Developers extends React.Component {

    state = {
        log: {}
    }

    update = async () => {

        this.setState({canSave: false})
        //copy state
        let newState = Object.assign({}, this.state.log);
        //assume we have no errors
        let errors = 0;

        required_form_fields.forEach((field) => {
            //check each required field
            if(newState[field]) {
                newState[field + "State"] = 'valid'; 
            } else {
                newState[field + "State"] = 'invalid'; 
                errors++
            }

        })

        this.setState({ log: newState });

        if(!errors) { 

            const cost = parseInt(this.props.viewing_user.hourly_rate) * (parseInt(newState.minutes) / 60)

            const updated = await architeckCall({
                method: 'patch',
                url: '/api/v1/crud/project_logs_developers/update/' + newState._id,
                data: {
                    ...newState,
                    cost 
                },
            });

           this.onToggleModal({})

            if(updated.success) {

                 //reset project_logs_developers
                this.setState({logs: {}})

                this.props.onUpdateDeveloperLog({
                    ...updated.data,
                    project: this.props.project,
                    user: this.props.viewing_user
                })

            } else {

                toggleAlert(true, 'danger', 'An error occurred.', '4000' )
                console.log(updated)

            }

        }

        //after load make sure button work again
        this.setState({canSave: true})

    }

    onInputChange = (e, stateName) => {

        let newState = Object.assign({}, this.state.log);
        newState[stateName] = e.target.value;

        if (stateName === "checkbox") {
          if (e.target.value) {
            newState.checkboxState = "valid";
          } else {
            newState.checkboxState = "invalid";
          }
        } else {
          if (e.target.value === "") {
            newState[stateName + "State"] = "invalid";
          } else {
            newState[stateName + "State"] = "valid";
          }
        }

        this.setState({ log: newState });
    };

    onToggleModal = (log) => this.setState({ log }) 

    showDeletionAlert = (row) => {
        this.setState({deletionAlert: (
            <ArchkNotificationDelete
                onSuccess={(response) => {

                    if(response.success) {

                        this.props.onRemoveDeveloperLog(response.data.document_ids_sent[0]);

                    } else {

                        toggleAlert(true, 'danger', 'An error occurred.', '4000' )
                        console.log(response)

                    }
                }}
                onError={(response) => {
                    toggleAlert(true, 'danger', 'An error occurred.', '4000' )
                }}
                onClose={() => this.setState({deletionAlert: null})}


                deletionURL={`${keys.API_URL}/api/v1/crud/project_logs_developers/delete/${row._id}`}
                apiKey={keys.SYSTEM_API_KEY}

                text="Are you sure you wish to delete this log? This cannot be undone."
                title={`Delete Project Log`}
            />
        )})
    }

    columns = [
        {
            dataField: "created_at",
            text: "Created ON",
            sort: true,
            formatter: (cell, row) => moment.unix(row.created_at).format("MM/DD/YYYY")
        },
        {
            dataField: "description",
            text: "Description",
            sort: true,
            formatter: (cell, row) => (
                <span>
                    {row.description && row.description.length > 30 ? row.description.slice(0,30) + '...' : row.description}
                </span>
            )
        }, {
            dataField: "problems",
            text: "Problems",
            sort: true,
            formatter: (cell, row) => (
                <span>
                    {row.problems && row.problems.length > 30 ? row.problems.slice(0,30) + '...' : row.problems}
                </span>
            )
        }, {
            dataField: "minutes",
            text: "Minutes",
            sort: true,
            formatter: (cell, row) => (
               <span>{row.minutes}</span>
            )
        }, {
            dataField: "cost",
            text: "Billable",
            sort: true,
            formatter: (cell, row) => (
               <span>${(row.cost / 100).toFixed(2)}</span>
            )
        }, {
            dataField: "",
            text: "Actions",
            sort: false,
            headerFormatter: (column) => <div className="text-right">Actions</div>,
            formatter: (cell, row) => {

                let current_time  = (Math.floor(new Date() / 1000));
                let one_week_unix_time = 604800;
                let last_week = current_time - one_week_unix_time

                //if this was created at a date before last week set disabled to true
                let disabled = row.created_at < last_week ? true : false

                return (
                    <div className="text-right">

                        <button onClick={() => this.onToggleModal(row)} disabled={disabled} className="btn btn-sm btn-primary">
                            <i className="fas fa-edit mr-2" />Edit 
                        </button>
                        <button  disabled={disabled}  onClick={() => this.showDeletionAlert(row)} className="btn btn-sm btn-danger">
                            <i className="fas fa-trash mr-2" />
                            Delete
                        </button>
                    
                    </div>
                )
            }
        }
    ]

    render() {

        const project_logs_developers = this.props.project_logs_developers
        const log = this.state.log;

        return (

            <>

                <Modal 
                    className="modal-full modal-dialog-centered" 
                    size="lg"  
                    isOpen={log._id ? true : false} 
                    toggle={() => this.onToggleModal({})}  
                >
                    <div className="modal-body">
                        <h2>Update Entry</h2>
                        <p>{moment.unix(log.created_at).format("MM/DD/YYYY")}</p>
                        <hr className="my-2" />

                        <FormGroup>
                            <label className="form-control-label" htmlFor="minutes" > 
                                Minutes Worked
                            </label>
                            <Input
                                id="minutes"
                                value={log.minutes || ''}
                                placeholder="60"
                                type="number"
                                valid={ log.minutesState === "valid" }
                                invalid={ log.minutesState === "invalid" }
                                onChange={e => this.onInputChange(e, "minutes") }
                            />
                            <div className="valid-feedback">Looks good!</div>
                        </FormGroup>

                        <FormGroup>
                            <label className="form-control-label" htmlFor="description" > 
                                description Worked
                            </label>
                            <Input
                                id="description"
                                value={log.description || ''}
                                placeholder="Added in API routes for... Created pages... fixed bug..."
                                type="textarea"
                                valid={ log.descriptionState === "valid" }
                                invalid={ log.descriptionState === "invalid" }
                                onChange={e => this.onInputChange(e, "description") }
                            />
                            <div className="valid-feedback">Looks good!</div>
                        </FormGroup>

                        <FormGroup>
                            <label className="form-control-label" htmlFor="problems" > 
                                Problems
                            </label>
                            <Input
                                id="problems"
                                value={log.problems || ''}
                                placeholder="After I clicked on... this happened..."
                                type="textarea"
                                valid={ log.problemsState === "valid" }
                                invalid={ log.problemsState === "invalid" }
                                onChange={e => this.onInputChange(e, "problems") }
                            />
                            <div className="valid-feedback">Looks good!</div>
                        </FormGroup>

                        <div className="text-right mt-3">
                            <button onClick={this.update} className="btn btn-success">Update</button>
                        </div>


                    </div>
                </Modal>

            <Card>

                {this.state.deletionAlert}


                <CardHeader>
                    <h2>All Project Logs</h2>
                    <p>Note you cannot update or delete a log that is older than 1 week.</p>
                   
                </CardHeader>

                <CardBody>

                    <div className="table-vertical-align">
                        <ToolkitProvider
                            data={project_logs_developers}
                            keyField="_id"
                            columns={this.columns}
                            search
                            exportCSV
                        >
                        {props => (
                            <div className="py-4 table-responsive table-vertical-align">
                                <div id="datatable-basic_filter" className="dataTables_filter px-4 pb-1 w-100" >
                                    <Row>

                                        <Col>
                                            <label>
                                                Search:
                                                <SearchBar className="form-control-sm" placeholder="" {...props.searchProps}/>
                                            </label>
                                        </Col>

                                        <Col className="col-auto">
                                            <ExportCSVButton { ...props.csvProps } className="btn-sm btn-success" >
                                                <span>Export CSV</span>
                                            </ExportCSVButton>
                                        </Col>

                                    </Row>
                                </div>
                                <BootstrapTable 
                                    {...props.baseProps} 
                                    className="xxx" 
                                    bootstrap4={true} 
                                    pagination={pagination} 
                                    bordered={false}
                                />
                            </div>
                        )}
                        </ToolkitProvider>
                    </div>

                </CardBody>
            </Card>

            </>

        );
    }
}



const mapStateToProps = state => {
    return {
  
      viewing_user: state.auth.viewing_user,
      app_projects: state.projects.app_projects,

    };
};
  
export default connect(mapStateToProps, '')(Developers);